
<template>
    <div class="container1">
		<div class="fushu-tip">温馨提示：附属账号也计入服务后台“支持买家数量”统计数量中</div>
		<el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="account-box">
			<el-form-item label="附属账号" prop="userName">
				<el-input v-model="ruleForm.userName" :minlength='11' :maxlength='11' clearable autocomplete= "new-password" onkeyup="value=value.replace(/[^\d]/g,'')" size="mini" style="width: 250px;margin-right:50px;" placeholder="请输入11位手机号"></el-input>
			</el-form-item>
			<el-form-item label="密码" prop="passWord">
				<el-input v-model="ruleForm.passWord" :minlength='6' :maxlength='20' clearable autocomplete= "new-password" onkeyup="value=value.replace(/[^\w\.\/]/ig,'')" type="password" size="mini" style="width: 250px;margin-right:50px;" placeholder="请填写6-20位字母和数字组合密码"></el-input>
			</el-form-item>
			<el-form-item label="备注" prop="memo">
				<el-input v-model="ruleForm.memo" size="mini" :maxlength='30' clearable style="width: 250px;margin-right:50px;" placeholder="最多支持输入30汉字"></el-input>
			</el-form-item>
			<el-button type="text" size="mini" @click="addAccount('ruleForm')">添加</el-button>
		</el-form>
		<div v-for="(item, index) in ruleForm2.accountList" :key="item.id">
			<el-form status-icon :model="ruleForm2" :rules="rules2" ref="ruleForm2" label-width="100px" class="account-box">
				<el-form-item label="附属账号" :prop="'accountList.' + index + '.userName'" :rules="rules2.userName">
					<el-input v-model="item.userName" :minlength='11' :maxlength='11' clearable autocomplete= "new-password" onkeyup="value=value.replace(/[^\d]/g,'')" v-if="item.canedit" size="mini" style="width: 250px;margin-right:50px;" placeholder="请输入11位手机号"></el-input>
					<div class="content" v-else>{{item.userName}}</div>
				</el-form-item>
				<el-form-item label="密码" :prop="'accountList.' + index + '.passWord'" :rules="rules2.passWord">
					<el-input v-model="item.passWord" :minlength='6' :maxlength='20' clearable autocomplete= "new-password" @keyup.delete.native="clearPassWord()" onkeyup="value=value.replace(/[^\w\.\/]/ig,'')" type="password" @input="editPassWord(item, index)" v-if="item.canedit" size="mini" style="width: 250px;margin-right:50px;" placeholder="请填写6-20位字母和数字组合密码"></el-input>
					<div class="content" v-else>********</div>
				</el-form-item>
				<el-form-item label="备注" prop="memo">
					<el-input v-model="item.memo" :maxlength='30' clearable v-if="item.canedit" size="mini" style="width: 250px;margin-right:50px;" placeholder="最多支持输入30汉字"></el-input>
					<div class="content" v-else>{{item.memo}}</div>
				</el-form-item>
				<el-button type="text" size="mini" v-if="item.canedit" @click="saveAccount('ruleForm2', item, index)">保存</el-button>
				<el-button type="text" size="mini" v-if="!item.canedit" @click="editAccount(item, index)">编辑</el-button>
				<el-button type="text" size="mini" @click="deleteAccount(item, index)">删除</el-button>
			</el-form>
		</div>
    </div>
</template>
<script>
export default {
	name: 'table-box',
	components: {
	},
	props: {
	},
	data () {
		var phone = (rule, value, callback) => {
			if (!(this.phoneReg.test(value))) {
				return callback(new Error('请输入正确手机号'))
			} else {
				callback()
			}
		}
		var phone2 = (rule, value, callback) => {
			if (!(this.phoneReg.test(value))) {
				return callback(new Error('请输入正确手机号'))
			} else {
				callback()
			}
		}
		return {
			customerid: '',
			isDisabled: true,
			AuthorityList: {
				'03_0001_0001_00': false,
				'03_0001_0002_00': false,
				'03_0001_0003_00': false,
				'03_0001_0004_00': false,
				'03_0001_0005_00': false,
				'03_0001_0006_00': false,
				'03_0001_0007_00': false,
				'03_0001_0008_00': false,
				'03_0001_0009_00': false,
				'03_0001_0010_00': false,
				'03_0001_0011_00': false
			},
			ruleForm: {
				userName: '',
				passWord: '',
				memo: ''
			},
			ruleForm2: {
				accountList: []
			},
			rules: {
				userName: [
					{ required: true, validator: phone, trigger: 'blur' }
				],
				passWord: [
					{ required: true,
						validator: (rule, value, callback) => {
							if (value) {
								if (!this.passwordReg.test(value)) {
									callback(new Error('密码格式不正确'))
								} else {
									callback()
								}
							} else {
								callback(new Error('密码不能为空'))
							}
						},
						trigger: 'blur'
					}
				]
			},
			rules2: {
				userName: [
					{ required: true, validator: phone2, trigger: 'blur' }
				],
				passWord: [
					{ required: true,
						validator: (rule, value, callback) => {
							if (value) {
								if (!this.passwordReg.test(value)) {
									callback(new Error('密码格式不正确'))
								} else {
									callback()
								}
							} else {
								callback(new Error('密码不能为空'))
							}
						},
						trigger: 'blur'
					}
				]
			},
			accountList: [],
			phoneReg: /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[0-9]{1})|(18[0-9]{1})|(19[0-9]{1}))+\d{8})$/,
			passwordReg: /^(?=.*[a-zA-Z]+)(?=.*[0-9]+)([a-zA-Z0-9]){6,20}$/,
			// checkPhoneFlag: false,
			// checkPassWordFlag: false,
			phoneWaring: null
		}
	},
	computed: {
		checkUserName () {
			return function (rule, value, callback) {
				if (!(this.phoneReg.test(value))) {
					return callback(new Error('请输入正确手机号'))
				} else {
					callback()
				}
			}
		}
	},
	created () {
		this.customerid = window.sessionStorage.getItem('customerid')
		this.getAuthority('03_0001_0000_00')
		this.getAccountList()
	},
	watch: {
	},
	methods: {
		getAuthority (pid) {
			let params = {
				pId: pid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		clearPassWord (item, index) {
			this.ruleForm2.accountList[index].passWord = ''
		},
		getAccountList () {
			let params = {
				id: this.customerid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIVShop}/customer/attachUser/list`,
				data: params
			}).then(res => {
				if (res.result) {
					this.ruleForm.userName = ''
					this.ruleForm.passWord = ''
					this.ruleForm.memo = ''
					this.ruleForm2.accountList = res.data
					if (this.ruleForm2.accountList.length > 0) {
						this.ruleForm2.accountList.forEach(item => {
							this.$set(item, 'canedit', false)
							this.$set(item, 'passWord', 'q111111')
						})
					}
				} else {
					this.$message.error(res.msg)
				}
			}).catch((res) => {
				this.$message.error(res.msg)
			})
		},
		addAccount (formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					if (this.ruleForm2.accountList.length > 0) {
						this.$message.error('最多只能添加一条附属账号信息！')
						return false
					}
					let params = {
						tel: this.ruleForm.userName,
						password: this.ruleForm.passWord,
						memo: this.ruleForm.memo,
						customerId: this.customerid
					}
					this.$store.dispatch('requestPost', {
						url: `${this.$fxBaseApi.urlIVShop}/customer/attachUser/create`,
						data: params
					}).then(res => {
						if (res.result) {
							this.$message.success('添加成功！')
							this.ruleForm.userName = ''
							this.ruleForm.passWord = ''
							this.ruleForm.memo = ''
							this.getAccountList()
						} else {
							this.$message.error(res.msg)
						}
					}).catch((res) => {
						this.$message.error(res.msg)
					})
				} else {
					return false
				}
			})
		},
		deleteAccount (item, index) {
			let params = {
				userId: item.id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIVShop}/customer/attachUser/remove`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('删除成功！')
					this.ruleForm2.accountList.splice(index, 1)
				} else {
					this.$message.error(res.msg)
				}
			}).catch((res) => {
				this.$message.error(res.msg)
			})
		},
		editAccount (item, index) {
			this.ruleForm2.accountList[index].canedit = true
		},
		editPassWord (item, index) {
			this.ruleForm2.accountList[index].editPassWord = item.passWord
		},
		saveAccount (formName, item, index) {
			this.$refs[formName][index].validate((valid) => {
				if (valid) {
					let params = {
						tel: item.userName,
						password: item.editPassWord ? item.editPassWord : '',
						memo: item.memo,
						userId: item.id
					}
					this.$store.dispatch('requestPost', {
						url: `${this.$fxBaseApi.urlIVShop}/customer/attachUser/update`,
						data: params
					}).then(res => {
						if (res.result) {
							this.$message.success('修改成功！')
							this.ruleForm2.accountList[index].canedit = false
						} else {
							this.$message.error(res.msg)
						}
					}).catch((res) => {
						this.$message.error(res.msg)
					})
				}
			})
		}
	}
}
</script>
<style lang="stylus" scoped>
.container1{
	width: 100%;
	flex-direction: column !important;
	height:calc(100% - 20px) ;
	margin: 20px;
	overflow: scroll;
	.account-box {
		display: flex;
		align-items: center;
		margin:10px 0;
		.content {
			width: 250px;
			margin-right: 50px;
			display: inline-block;
			text-align: left;
		}
	}
	.fushu-tip {
		text-align: left;
		text-indent: 30px;
		font-size: 14px;
		color: red;
	}
}

</style>
<style lang="stylus">
.el-input__inner{
	line-height: 1px !important;
}
</style>
